import { Form, Formik } from "formik";
import * as Yup from "yup";
import Button from "../../../shared/ui/Button";
import { FormRadioGroup } from "../../../shared/ui/Form/FormRadioGroup";

const plantStatusOptions = [
    {
        value: "active",
        label: "Activate Plant",
        subLabel: "active plant, customer is still looking for solar",
    },
    {
        value: "inactive",
        label: "Deactivate Plant",
        subLabel: "disable plant, customer no longer need solar",
    },
];

const validationSchema = Yup.object().shape({
    plantStatus: Yup.string().required("Plant status is required"),
});

const PlantStatusForm = ({ onSucess = () => {} }) => {
    return (
        <div className="p-4">
            <Formik
                enableReinitialize
                initialValues={{
                    plantStatus: "active",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    onSucess(values);
                }}
            >
                {() => (
                    <Form className="space-y-3">
                        <FormRadioGroup
                            name="plantStatus"
                            label="Set Plant Status: ACTIVE or DISABLE"
                            wrapperClass="flex-col "
                            labelClass="text-xs !text-gray-330"
                            optionContainerClass="gap-2 md:gap-5"
                            options={plantStatusOptions}
                        />

                        <Button
                            type="submit"
                            className="bg-blue-700 text-white w-full"
                        >
                            Submit
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default PlantStatusForm;
